import { openLogin } from '@/api/finance/wechat'
import { getLoginToken } from '@/api/general/wechat'
import { getWechatCode, getWechatOrgCode } from '@/utils/common'
export const initWx = function () {
  // 首先要调用微信的jsdk
  return new Promise((resolve, reject) => {
    getWechatCode().then((code) => {
      getLoginToken({ code: code, nickname: 'EDG' }).then((res) => {
        // 不管是自己写的方法还是后台给的接口方法都可以，只要这个方法有这个wx.config需要的参数
        localStorage.setItem('openid', res.data.openid)
        resolve(res.data)
      })
    })
  })
}

export const initOrgWx = function () {
  // 首先要调用微信的jsdk
  return new Promise((resolve, reject) => {
    getWechatOrgCode().then((code) => {
      if (!localStorage.getItem('orgId') || localStorage.getItem('orgId') == 'undefined') {
        alert('缺少orgId')
        return false
      }
      openLogin({
        code: code,
        orgId: localStorage.getItem('orgId')
      })
        .then((res) => {
          const { data } = res
          localStorage.setItem('orgOpenid', data.openid)
          // localStorage.setItem('Token', data.access_token)
          resolve(res.data)
        })
        .catch(() => {
          localStorage.setItem('orgOpenid', '')
        })
    })
  })
}
